<script>
  export default {
    props: {
      color: {
        type: String,
        required: false,
        default: "var(--neutral-500)",
      },
      width: {
        type: Number,
        required: false,
        default: 16,
      },
      height: {
        type: Number,
        required: false,
        default: 16,
      },
    },
  };
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_12420_28060"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="14"
      height="14"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.00065 1.33398C4.31398 1.33398 1.33398 4.31398 1.33398 8.00065C1.33398 11.6873 4.31398 14.6673
        8.00065 14.6673C11.6873 14.6673 14.6673 11.6873 14.6673 8.00065C14.6673 4.31398 11.6873
        1.33398 8.00065 1.33398ZM9.26065 5.80066L8.00065 7.06066L6.74065 5.80066C6.6161 5.67582 6.447
        5.60567 6.27065 5.60567C6.09431 5.60567 5.9252 5.67582 5.80065 5.80066C5.54065 6.06066 5.54065
        6.48066 5.80065 6.74066L7.06065 8.00066L5.80065 9.26066C5.54065 9.52066 5.54065 9.94066 5.80065
        10.2007C6.06065 10.4607 6.48065 10.4607 6.74065 10.2007L8.00065 8.94066L9.26065 10.2007C9.52065
        10.4607 9.94065 10.4607 10.2007 10.2007C10.4607 9.94066 10.4607 9.52066 10.2007 9.26066L8.94065
        8.00066L10.2007 6.74066C10.4607 6.48066 10.4607 6.06066 10.2007 5.80066C9.94065 5.54732 9.51398
        5.54732 9.26065 5.80066ZM2.66732 8.00065C2.66732 10.9407 5.06065 13.334 8.00065 13.334C10.9407
        13.334 13.334 10.9407 13.334 8.00065C13.334 5.06065 10.9407 2.66732 8.00065 2.66732C5.06065
        2.66732 2.66732 5.06065 2.66732 8.00065Z"
        :fill="color"
      />
    </mask>
    <g mask="url(#mask0_12420_28060)">
      <rect
        :width="width"
        :height="height"
        :fill="color"
      />
    </g>
  </svg>
</template>
<style scoped lang="sass"></style>
